import React, {useEffect} from 'react'
import {Banner, Quote, Features, Video, Team} from '../../Components/About'
import features from '../../Constants/features';
import team from '../../Constants/team';
import { useTranslation } from 'react-i18next';

function About() {
    const { t } = useTranslation();
    const banner = {
        title : 'About our Hotel',
        description : t('main.firstDescription'),
        navigation: [{title: t('main.about'), path: '/about'}]
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
    
        <>
            {/* <!-- banner --> */}
            <Banner data={banner}/>
            {/* <!-- banner end --> */}

            {/* <!-- quote --> */}
            <Quote/>
            {/* <!-- quote end --> */}

            {/* <!-- features --> */}
            <Features items={features}/>
            {/* <!-- features end --> */}

            {/* <!-- video --> */}
            <Video />
            {/* <!-- video end --> */}

            {/* <!-- team --> */}
            <Team items={team}/>
            {/* <!-- team end --> */}
        </>

    );
}

export default About as React.FC